(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[734],{

/***/ 13951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2248);
/* harmony import */ var _LuggageButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63267);
/* harmony import */ var _LuggageButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_LuggageButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var LuggageButtonComponent = function(param) {
    var sizeStepper = param.sizeStepper, setSizeStepper = param.setSizeStepper, count = param.count, buttonStyle = param.buttonStyle;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_LuggageButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().stepper),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "".concat((_LuggageButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().countDownButton), " ").concat(buttonStyle),
                onClick: function() {
                    return setSizeStepper(sizeStepper - 1);
                },
                disabled: sizeStepper > count || sizeStepper === 0,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/stepper_decrement_icon.svg",
                    alt: t("META.STEPPER_DECREMENT_ICON"),
                    width: 14,
                    height: 3
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_LuggageButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().count),
                children: sizeStepper
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "".concat((_LuggageButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_2___default().countDownButton), " ").concat(buttonStyle),
                onClick: function() {
                    return setSizeStepper(sizeStepper + 1);
                },
                disabled: sizeStepper >= count || sizeStepper === 200,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/stepper_increment_icon.svg",
                    alt: t("META.STEPPER_INCREMENT_ICON"),
                    width: 12,
                    height: 12
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LuggageButtonComponent);


/***/ }),

/***/ 81691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ModalCloseButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33162);
/* harmony import */ var _ModalCloseButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ModalCloseButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var ModalCloseButtonComponent = function(param) {
    var onPressCloseModalRequest = param.onPressCloseModalRequest, closeButtonStyle = param.closeButtonStyle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_ModalCloseButtonComponent_module_scss__WEBPACK_IMPORTED_MODULE_1___default().defaultCloseButton), " ").concat(closeButtonStyle),
        onClick: onPressCloseModalRequest,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalCloseButtonComponent);


/***/ }),

/***/ 19448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ModalLayout_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65184);
/* harmony import */ var _ModalLayout_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ModalLayout_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var ModalLayout = function(param) {
    var children = param.children, openModal = param.openModal, onPressCloseModalRequest = param.onPressCloseModalRequest, modalStyle = param.modalStyle, overlayClassName = param.overlayClassName, shouldCloseOnOverlayClick = param.shouldCloseOnOverlayClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_modal__WEBPACK_IMPORTED_MODULE_1___default()), {
        isOpen: openModal,
        className: modalStyle,
        onRequestClose: onPressCloseModalRequest,
        overlayClassName: overlayClassName || (_ModalLayout_module_scss__WEBPACK_IMPORTED_MODULE_2___default().modalOverlay),
        ariaHideApp: false,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalLayout);


/***/ }),

/***/ 4816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ spaces_SearchForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 13 modules
var esm = __webpack_require__(2248);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dates/index.js
var react_dates = __webpack_require__(76141);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/data/hour_list.json
var hour_list_namespaceObject = JSON.parse('[{"hour":"9:00"},{"hour":"9:30"},{"hour":"10:00"},{"hour":"10:30"},{"hour":"11:00"},{"hour":"11:30"},{"hour":"12:00"},{"hour":"12:30"},{"hour":"13:00"},{"hour":"13:30"},{"hour":"14:00"},{"hour":"14:30"},{"hour":"15:00"},{"hour":"15:30"},{"hour":"16:00"},{"hour":"16:30"},{"hour":"17:00"},{"hour":"17:30"},{"hour":"18:00"},{"hour":"18:30"},{"hour":"19:00"},{"hour":"19:30"},{"hour":"20:00"},{"hour":"20:30"},{"hour":"21:00"},{"hour":"21:30"},{"hour":"22:00"},{"hour":"22:30"},{"hour":"23:00"},{"hour":"23:30"},{"hour":"0:00"},{"hour":"0:30"},{"hour":"1:00"},{"hour":"1:30"},{"hour":"2:00"},{"hour":"2:30"},{"hour":"3:00"},{"hour":"3:30"},{"hour":"4:00"},{"hour":"4:30"},{"hour":"5:00"},{"hour":"5:30"},{"hour":"6:00"},{"hour":"6:30"},{"hour":"7:00"},{"hour":"7:30"},{"hour":"8:00"},{"hour":"8:30"}]');
// EXTERNAL MODULE: ./src/utils/calendar.ts
var calendar = __webpack_require__(60849);
// EXTERNAL MODULE: ./src/components/calendars/DateRangeCalendarComponent.module.scss
var DateRangeCalendarComponent_module = __webpack_require__(92328);
var DateRangeCalendarComponent_module_default = /*#__PURE__*/__webpack_require__.n(DateRangeCalendarComponent_module);
;// CONCATENATED MODULE: ./src/components/calendars/DateRangeCalendarComponent.tsx





moment_default().locale("ja");



var DateRangeCalendarComponent = function(param) {
    var locale = param.locale, isShow = param.isShow, isShowTimePicker = param.isShowTimePicker, onPressCloseModalRequest = param.onPressCloseModalRequest, selectedDate = param.selectedDate, setSelectedDate = param.setSelectedDate, selectedDateTime = param.selectedDateTime, setSelectedDateTime = param.setSelectedDateTime;
    var ref = (0,react.useState)("startDate"), focused = ref[0], setFocused = ref[1];
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isShow && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dates.DayPickerRangeController, {
            startDate: selectedDate.startDate,
            endDate: selectedDate.endDate,
            onDatesChange: function(param) {
                var startDate = param.startDate, endDate = param.endDate;
                setSelectedDate({
                    startDate: startDate,
                    endDate: endDate
                });
            },
            navPrev: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (DateRangeCalendarComponent_module_default()).prev
            }),
            navNext: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (DateRangeCalendarComponent_module_default()).next
            }),
            isOutsideRange: function(day) {
                return day.isSameOrAfter(moment_default()().add(3, "month")) || !(0,react_dates.isInclusivelyAfterDay)(day, moment_default()());
            },
            hideKeyboardShortcutsPanel: true,
            focusedInput: focused,
            onFocusChange: function(focusedInput) {
                setFocused(!focusedInput ? "startDate" : focusedInput);
            },
            monthFormat: locale === "ja" ? "YYYY[年]MM[月]" : "YYYY/MM",
            onOutsideClick: function() {
                onPressCloseModalRequest();
            },
            minimumNights: 0,
            initialVisibleMonth: null,
            renderWeekHeaderElement: function(day) {
                var ref;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (DateRangeCalendarComponent_module_default()).weekHeader,
                    children: calendar/* calendarWeekHeader */.Y === null || calendar/* calendarWeekHeader */.Y === void 0 ? void 0 : (ref = calendar/* calendarWeekHeader */.Y[day]) === null || ref === void 0 ? void 0 : ref[locale]
                });
            },
            renderCalendarInfo: function() {
                if (!isShowTimePicker) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (DateRangeCalendarComponent_module_default()).timePicker,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (DateRangeCalendarComponent_module_default()).timePickerContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (DateRangeCalendarComponent_module_default()).timePickerTimes,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (DateRangeCalendarComponent_module_default()).timePickerTime,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                className: (DateRangeCalendarComponent_module_default()).timePickerTimeTitle,
                                                children: t("SPACES.SEARCH.CHECK_IN_TIME")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                className: (DateRangeCalendarComponent_module_default()).timePickerTimeSelect,
                                                value: selectedDateTime.startDateTime,
                                                onChange: function(e) {
                                                    selectedDateTime.startDateTime = e.target.value;
                                                    setSelectedDateTime({
                                                        startDateTime: selectedDateTime.startDateTime,
                                                        endDateTime: selectedDateTime.endDateTime
                                                    });
                                                },
                                                children: hour_list_namespaceObject.map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: item.hour,
                                                        children: item.hour
                                                    }, index);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (DateRangeCalendarComponent_module_default()).timePickerTime,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                className: (DateRangeCalendarComponent_module_default()).timePickerTimeTitle,
                                                children: t("SPACES.SEARCH.CHECK_OUT_TIME")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                className: (DateRangeCalendarComponent_module_default()).timePickerTimeSelect,
                                                value: selectedDateTime.endDateTime,
                                                onChange: function(e) {
                                                    selectedDateTime.endDateTime = e.target.value;
                                                    setSelectedDateTime({
                                                        startDateTime: selectedDateTime.startDateTime,
                                                        endDateTime: selectedDateTime.endDateTime
                                                    });
                                                },
                                                children: hour_list_namespaceObject.map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: item.hour,
                                                        children: item.hour
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (DateRangeCalendarComponent_module_default()).timePickerDescription,
                                children: t("SPACES.SEARCH.SELECT_ABOUT_TIME")
                            })
                        ]
                    })
                });
            }
        })
    });
};
/* harmony default export */ var calendars_DateRangeCalendarComponent = (DateRangeCalendarComponent);

// EXTERNAL MODULE: ./node_modules/react-loader-spinner/dist/esm/index.js + 45 modules
var dist_esm = __webpack_require__(51580);
// EXTERNAL MODULE: ./src/components/commons/layouts/ModalLayout.tsx
var ModalLayout = __webpack_require__(19448);
// EXTERNAL MODULE: ./src/components/buttons/ModalCloseButtonComponent.tsx
var ModalCloseButtonComponent = __webpack_require__(81691);
// EXTERNAL MODULE: ./src/features/places/hooks/usePlaceAutoCompletion.ts + 1 modules
var usePlaceAutoCompletion = __webpack_require__(21546);
// EXTERNAL MODULE: ./src/components/domains/spaces/SearchAreaModal.module.scss
var SearchAreaModal_module = __webpack_require__(81973);
var SearchAreaModal_module_default = /*#__PURE__*/__webpack_require__.n(SearchAreaModal_module);
;// CONCATENATED MODULE: ./src/components/domains/spaces/SearchAreaModal.tsx










var SearchAreaModal = function(param) {
    var isShow = param.isShow, defaultAreaName = param.defaultAreaName, _hideSearchCurrentPosition = param.hideSearchCurrentPosition, hideSearchCurrentPosition = _hideSearchCurrentPosition === void 0 ? false : _hideSearchCurrentPosition, _isRequestLocationPermission = param.isRequestLocationPermission, isRequestLocationPermission = _isRequestLocationPermission === void 0 ? false : _isRequestLocationPermission, onPressCloseModalRequest = param.onPressCloseModalRequest, onPressApplyButton = param.onPressApplyButton, onPressCurrentPosition = param.onPressCurrentPosition;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)({
        lat: 0,
        lon: 0
    }), latLng = ref[0], setLatLng = ref[1];
    var ref1 = (0,usePlaceAutoCompletion/* usePlaceAutoCompletion */.s)(), places = ref1.places, setPlaces = ref1.setPlaces, searchText = ref1.searchText, setSearchText = ref1.setSearchText, setSearchTextFromInput = ref1.setSearchTextFromInput, selectPlace = ref1.selectPlace;
    var ref2 = (0,react.useState)(""), inputText = ref2[0], setInputText = ref2[1];
    (0,react.useEffect)(function() {
        if (defaultAreaName) {
            setInputText(defaultAreaName);
            setSearchText(defaultAreaName);
        }
    }, [
        defaultAreaName,
        setSearchText
    ]);
    (0,react.useEffect)(function() {
        if (!isShow) {
            setPlaces([]);
            setSearchText("");
            setInputText("");
        }
    }, [
        isShow,
        setPlaces,
        setSearchText
    ]);
    var _handleSelect = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(place) {
            var geocode, lat, lng;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setInputText(place.description);
                        setSearchText("");
                        setPlaces([]);
                        return [
                            4,
                            selectPlace(place)
                        ];
                    case 1:
                        geocode = _state.sent();
                        if (geocode) {
                            lat = geocode.lat, lng = geocode.lng;
                            setLatLng({
                                lat: lat,
                                lon: lng
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(place) {
            return _ref.apply(this, arguments);
        };
    }(), [
        selectPlace,
        setPlaces,
        setSearchText
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalLayout/* default */.Z, {
        openModal: isShow,
        onPressCloseModalRequest: onPressCloseModalRequest,
        modalStyle: (SearchAreaModal_module_default()).modal,
        overlayClassName: (SearchAreaModal_module_default()).modalOverlay,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (SearchAreaModal_module_default()).modalContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCloseButtonComponent/* default */.Z, {
                    onPressCloseModalRequest: onPressCloseModalRequest,
                    closeButtonStyle: (SearchAreaModal_module_default()).modalCloseButton
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SearchAreaModal_module_default()).modalTitle,
                    children: t("COMMON.AREA")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SearchAreaModal_module_default()).modalContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SearchAreaModal_module_default()).areaBox,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: (SearchAreaModal_module_default()).areaLabel,
                                    children: t("SPACES.SEARCH.AREA.PLACEHOLDER")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (SearchAreaModal_module_default()).areaInputBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        className: (SearchAreaModal_module_default()).areaInputBoxInput,
                                        placeholder: t("SPACES.SEARCH.AREA_MODAL.ENTER_AREA_NAME"),
                                        value: inputText,
                                        onChange: function(event) {
                                            var text = event.target.value;
                                            setSearchTextFromInput(text);
                                            setInputText(text);
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: (SearchAreaModal_module_default()).areaChoiceList,
                            children: [
                                !hideSearchCurrentPosition && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: (SearchAreaModal_module_default()).areaChoiceItem,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: (SearchAreaModal_module_default()).areaChoiceButton,
                                        onClick: onPressCurrentPosition,
                                        disabled: isRequestLocationPermission,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "".concat((SearchAreaModal_module_default()).areaChoiceIcon, " ").concat((SearchAreaModal_module_default()).areaChoiceIconCurrent),
                                                src: "/current_location_icon.svg",
                                                alt: t("ALT.SEARCH_CURRENT_LOCATION_ICON")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: isRequestLocationPermission ? {
                                                    color: "#8D8D8D"
                                                } : {},
                                                className: (SearchAreaModal_module_default()).areaChoiceText,
                                                children: isRequestLocationPermission ? t("TOP.BUTTONS.REQUESTING_LOCATION_PERMISSION") : t("TOP.BUTTONS.SEARCH_CURRENT_LOCATION")
                                            }),
                                            isRequestLocationPermission && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* TailSpin */.gy, {
                                                color: "#8D8D8D",
                                                width: 16,
                                                height: 16
                                            })
                                        ]
                                    })
                                }),
                                !!searchText && !!places.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: places.map(function(suggestion) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: function() {
                                                return _handleSelect(suggestion);
                                            },
                                            className: (SearchAreaModal_module_default()).areaChoiceItem,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                type: "button",
                                                className: (SearchAreaModal_module_default()).areaChoiceButton,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "".concat((SearchAreaModal_module_default()).areaChoiceIcon, " ").concat((SearchAreaModal_module_default()).areaChoiceIconMapPin),
                                                        src: "/map_pin_icon_navy_dark.svg",
                                                        alt: t("META.NOT_MATCHING_SPACE_ICON")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (SearchAreaModal_module_default()).areaChoiceText,
                                                        children: suggestion.description
                                                    })
                                                ]
                                            })
                                        }, suggestion.place_id);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (SearchAreaModal_module_default()).modalApplyButton,
                    onClick: function() {
                        onPressApplyButton(inputText, latLng);
                    },
                    children: t("COMMON.DO_APPLY")
                })
            ]
        })
    });
};
/* harmony default export */ var spaces_SearchAreaModal = (SearchAreaModal);

// EXTERNAL MODULE: ./src/components/buttons/LuggageButtonComponent.tsx
var LuggageButtonComponent = __webpack_require__(13951);
// EXTERNAL MODULE: ./src/components/domains/spaces/SearchDateLuggageModal.module.scss
var SearchDateLuggageModal_module = __webpack_require__(86751);
var SearchDateLuggageModal_module_default = /*#__PURE__*/__webpack_require__.n(SearchDateLuggageModal_module);
;// CONCATENATED MODULE: ./src/components/domains/spaces/SearchDateLuggageModal.tsx




moment_default().locale("ja");






var SearchDateLuggageModal = function(param) {
    var locale = param.locale, isShow = param.isShow, onPressCloseModalRequest = param.onPressCloseModalRequest, onPressApplyButton = param.onPressApplyButton, selectedDate = param.selectedDate, selectedDateTime = param.selectedDateTime, defaultBagSizeStepper = param.defaultBagSizeStepper, defaultSuitcaseSizeStepper = param.defaultSuitcaseSizeStepper, isVisibleFilterButton = param.isVisibleFilterButton, onPressSearchFilterModal = param.onPressSearchFilterModal;
    var ref, ref1;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref2 = (0,react.useState)(false), isShowDateCalendar = ref2[0], setIsShowDateCalendar = ref2[1];
    var ref3 = (0,react.useState)({
        startDate: selectedDate.startDate,
        endDate: selectedDate.endDate
    }), checkedDate = ref3[0], setCheckedDate = ref3[1];
    var ref4 = (0,react.useState)(selectedDateTime), dateTime = ref4[0], setDateTime = ref4[1];
    var ref5 = (0,react.useState)(defaultBagSizeStepper), bagSizeStepper = ref5[0], setBagSizeStepper = ref5[1];
    var ref6 = (0,react.useState)(defaultSuitcaseSizeStepper), suitcaseSizeStepper = ref6[0], setSuitcaseSizeStepper = ref6[1];
    var ref7, ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalLayout/* default */.Z, {
        openModal: isShow,
        onPressCloseModalRequest: onPressCloseModalRequest,
        modalStyle: (SearchDateLuggageModal_module_default()).modal,
        overlayClassName: (SearchDateLuggageModal_module_default()).modalOverlay,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (SearchDateLuggageModal_module_default()).modalContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCloseButtonComponent/* default */.Z, {
                    onPressCloseModalRequest: onPressCloseModalRequest,
                    closeButtonStyle: (SearchDateLuggageModal_module_default()).modalCloseButton
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SearchDateLuggageModal_module_default()).modalTitle,
                    children: t("SPACES.SEARCH.CHECK_DATETIME_LUGGAGE")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SearchDateLuggageModal_module_default()).modalContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SearchDateLuggageModal_module_default()).dateBox,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: (SearchDateLuggageModal_module_default()).dateLabel,
                                    children: t("SPACES.SEARCH.CHECK_DATE")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SearchDateLuggageModal_module_default()).dateInputBox,
                                    children: [
                                        checkedDate.startDate === null && checkedDate.endDate === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "".concat((SearchDateLuggageModal_module_default()).dateInputBoxPlaceholder, " ").concat((SearchDateLuggageModal_module_default()).dateInputBoxPlaceholderDate),
                                            onClick: function() {
                                                setIsShowDateCalendar(!isShowDateCalendar);
                                            },
                                            children: t("SPACES.SEARCH.ENTER_DATE")
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((SearchDateLuggageModal_module_default()).dateInputBoxResult, " ").concat((SearchDateLuggageModal_module_default()).dateInputBoxResultDate),
                                            onClick: function() {
                                                setIsShowDateCalendar(!isShowDateCalendar);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (SearchDateLuggageModal_module_default()).dateInputBoxResultDateText,
                                                    children: [
                                                        (ref7 = (ref = checkedDate.startDate) === null || ref === void 0 ? void 0 : ref.format("YYYY/MM/DD")) !== null && ref7 !== void 0 ? ref7 : "",
                                                        " ",
                                                        dateTime.startDateTime
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (SearchDateLuggageModal_module_default()).dateInputBoxResultDateText,
                                                    children: "-"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (SearchDateLuggageModal_module_default()).dateInputBoxResultDateText,
                                                    children: [
                                                        (ref8 = (ref1 = checkedDate.endDate) === null || ref1 === void 0 ? void 0 : ref1.format("YYYY/MM/DD")) !== null && ref8 !== void 0 ? ref8 : "",
                                                        " ",
                                                        dateTime.endDateTime
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (SearchDateLuggageModal_module_default()).dateInputBoxDateCalendar,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(calendars_DateRangeCalendarComponent, {
                                                locale: locale,
                                                isShow: isShowDateCalendar,
                                                isShowTimePicker: false,
                                                onPressCloseModalRequest: function() {
                                                    setIsShowDateCalendar(false);
                                                },
                                                selectedDate: checkedDate,
                                                setSelectedDate: setCheckedDate
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SearchDateLuggageModal_module_default()).dateTimeContents,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SearchDateLuggageModal_module_default()).dateTimeBox,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: (SearchDateLuggageModal_module_default()).dateLabel,
                                            children: t("SPACES.SEARCH.CHECK_DATETIME")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                            className: (SearchDateLuggageModal_module_default()).dateTimeSelect,
                                            value: dateTime.startDateTime,
                                            onChange: function(e) {
                                                dateTime.startDateTime = e.target.value;
                                                setDateTime({
                                                    startDateTime: dateTime.startDateTime,
                                                    endDateTime: dateTime.endDateTime
                                                });
                                            },
                                            children: hour_list_namespaceObject.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: item.hour,
                                                    children: item.hour
                                                }, index);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SearchDateLuggageModal_module_default()).dateTimeBox,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: (SearchDateLuggageModal_module_default()).dateLabel,
                                            children: t("SPACES.SEARCH.CHECK_OUT_DATETIME")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                            className: (SearchDateLuggageModal_module_default()).dateTimeSelect,
                                            value: dateTime.endDateTime,
                                            onChange: function(e) {
                                                dateTime.endDateTime = e.target.value;
                                                setDateTime({
                                                    startDateTime: dateTime.startDateTime,
                                                    endDateTime: dateTime.endDateTime
                                                });
                                            },
                                            children: hour_list_namespaceObject.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: item.hour,
                                                    children: item.hour
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (SearchDateLuggageModal_module_default()).dateTimeDescription,
                            children: t("SPACES.SEARCH.SELECT_CHECK_IN_ABOUT_DATETIME")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SearchDateLuggageModal_module_default()).luggageContents,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SearchDateLuggageModal_module_default()).luggage,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (SearchDateLuggageModal_module_default()).luggageIcon,
                                            src: "/bag_icon_gray.svg",
                                            alt: t("META.PLACEHOLDER_LUGGAGE_ICON")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            className: (SearchDateLuggageModal_module_default()).luggageLabel,
                                            children: t("COMMON.BAG_SIZE")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (SearchDateLuggageModal_module_default()).luggageDescription,
                                            children: t("SPACES.SEARCH.LUGGAGE.BAG_SIZE_DESCRIPTION_SHORT")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (SearchDateLuggageModal_module_default()).luggageStepper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LuggageButtonComponent/* default */.Z, {
                                                sizeStepper: bagSizeStepper,
                                                setSizeStepper: setBagSizeStepper,
                                                buttonStyle: (SearchDateLuggageModal_module_default()).luggageStepperButton
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SearchDateLuggageModal_module_default()).luggage,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (SearchDateLuggageModal_module_default()).luggageIcon,
                                            src: "/suitcase_icon_gray_no_margin.svg",
                                            alt: t("META.PLACEHOLDER_LUGGAGE_ICON")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            className: (SearchDateLuggageModal_module_default()).luggageLabel,
                                            children: t("COMMON.SUITECASE_SIZE")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (SearchDateLuggageModal_module_default()).luggageDescription,
                                            children: t("SPACES.SEARCH.LUGGAGE.SUITCASE_SIZE_DESCRIPTION_SHORT")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (SearchDateLuggageModal_module_default()).luggageStepper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LuggageButtonComponent/* default */.Z, {
                                                sizeStepper: suitcaseSizeStepper,
                                                setSizeStepper: setSuitcaseSizeStepper,
                                                buttonStyle: (SearchDateLuggageModal_module_default()).luggageStepperButton
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        isVisibleFilterButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SearchDateLuggageModal_module_default()).filterContent,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (SearchDateLuggageModal_module_default()).filterButton,
                                type: "button",
                                onClick: onPressSearchFilterModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (SearchDateLuggageModal_module_default()).filterButtonText,
                                    children: t("COMMON.DO_FILTER")
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (SearchDateLuggageModal_module_default()).modalApplyButton,
                    onClick: function() {
                        onPressApplyButton(checkedDate, dateTime, bagSizeStepper, suitcaseSizeStepper);
                    },
                    children: t("COMMON.DO_APPLY")
                })
            ]
        })
    });
};
/* harmony default export */ var spaces_SearchDateLuggageModal = (SearchDateLuggageModal);

// EXTERNAL MODULE: ./src/lib/checkBreakpoint.ts
var checkBreakpoint = __webpack_require__(92122);
// EXTERNAL MODULE: ./src/components/domains/spaces/SearchForm.module.scss
var SearchForm_module = __webpack_require__(77922);
var SearchForm_module_default = /*#__PURE__*/__webpack_require__.n(SearchForm_module);
// EXTERNAL MODULE: ./src/features/tracking/lib/location.ts
var lib_location = __webpack_require__(45060);
// EXTERNAL MODULE: ./src/lib/gtag.ts
var gtag = __webpack_require__(31418);
;// CONCATENATED MODULE: ./src/components/domains/spaces/SearchForm.tsx
















var SearchForm = function(param) {
    var page = param.page, onPressSearchSpace = param.onPressSearchSpace, setSearchParams = param.setSearchParams, onPressNavigationSearchSpacePage = param.onPressNavigationSearchSpacePage, isVisibleFilterButton = param.isVisibleFilterButton, onPressSearchFilterModal = param.onPressSearchFilterModal, locale = param.locale;
    var query = (0,router.useRouter)().query;
    var t = (0,esm/* useTranslation */.$G)().t;
    var isDesktop = (0,checkBreakpoint/* default */.Z)().isDesktop;
    var ref = (0,react.useState)(false), isShowDateCalendar = ref[0], setIsShowDateCalendar = ref[1];
    var ref1 = (0,react.useState)(false), isShowAreaModal = ref1[0], setIsShowAreaModal = ref1[1];
    var ref2 = (0,react.useState)(false), isShowDateLuggageModal = ref2[0], setIsShowDateLuggageModal = ref2[1];
    var luggageRef = (0,react.useRef)(null);
    var ref3 = (0,react.useState)(false), openLuggage = ref3[0], setOpenLuggage = ref3[1];
    var ref4 = (0,react.useState)(Number(query.bagSize) || 0), bagSizeStepper = ref4[0], setBagSizeStepper = ref4[1];
    var ref5 = (0,react.useState)(Number(query.suitcaseSize) || 0), suitcaseSizeStepper = ref5[0], setSuitcaseSizeStepper = ref5[1];
    var ref6 = (0,react.useState)({
        lat: 0,
        lon: 0
    }), latLng = ref6[0], setLatLng = ref6[1];
    var ref7 = (0,react.useState)({
        startDate: query.startDate ? moment_default()(query.startDate) : null,
        endDate: query.startDate ? moment_default()(query.endDate) : null
    }), selectedDate = ref7[0], setSelectedDate = ref7[1];
    var ref8 = (0,react.useState)(false), isRequestLocationPermission = ref8[0], setIsRequestLocationPermission = ref8[1];
    var ref9 = (0,usePlaceAutoCompletion/* usePlaceAutoCompletion */.s)(), places = ref9.places, setPlaces = ref9.setPlaces, searchText = ref9.searchText, setSearchText = ref9.setSearchText, setSearchTextFromInput = ref9.setSearchTextFromInput, selectPlace = ref9.selectPlace;
    var ref10 = (0,react.useState)(""), inputText = ref10[0], setInputText = ref10[1];
    var getDefaultDateTime = function(type) {
        var dateTime = "";
        if (type === "start") {
            if (query.startDateTimeHour && query.startDateTimeMin) {
                dateTime = "".concat(query.startDateTimeHour, ":").concat(query.startDateTimeMin);
            } else if (query.startDateTimeHour) {
                dateTime = "".concat(query.startDateTimeHour, ":00");
            } else {
                var now = moment_default()();
                if (now.get("minutes") < 30) {
                    now.set("minutes", 30);
                } else {
                    now.set({
                        hours: now.get("hours") + 1,
                        minutes: 0
                    });
                }
                dateTime = "".concat(now.get("hours").toString().padStart(2, "0"), ":").concat(now.get("minutes").toString().padStart(2, "0"));
            }
        } else {
            if (query.endDateTimeHour && query.endDateTimeMin) {
                dateTime = "".concat(query.endDateTimeHour, ":").concat(query.endDateTimeMin);
            } else if (query.endDateTimeHour) {
                dateTime = "".concat(query.endDateTimeHour, ":00");
            } else {
                var now1 = moment_default()();
                if (now1.get("minutes") < 30) {
                    now1.set({
                        hours: now1.get("hours") + 2,
                        minutes: 30
                    });
                } else {
                    now1.set({
                        hours: now1.get("hours") + 3,
                        minutes: 0
                    });
                }
                dateTime = "".concat(now1.get("hours").toString().padStart(2, "0"), ":").concat(now1.get("minutes").toString().padStart(2, "0"));
            }
        }
        return dateTime;
    };
    var ref11 = (0,react.useState)({
        startDateTime: getDefaultDateTime("start"),
        endDateTime: getDefaultDateTime("end")
    }), selectedDateTime = ref11[0], setSelectedDateTime = ref11[1];
    var ref12 = (0,react.useState)(""), inputFocusType = ref12[0], setInputFocusType = ref12[1];
    var resetInputFocus = function() {
        setInputFocusType("");
    };
    //検索ボタンの有効フラグ
    var isSearchButtonActive = inputText === "" && (selectedDate.startDate === null || selectedDate.endDate === null) && bagSizeStepper === 0 && suitcaseSizeStepper === 0 ? true : false;
    //入力ボックスの横並び
    var isHorizontalInputBox = page === "locations" ? true : false;
    (0,react.useEffect)(function() {
        document.addEventListener("click", _onPressLuggageContainer);
        return function() {
            document.removeEventListener("click", _onPressLuggageContainer);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (query.startDate && query.endDate) {
            setSelectedDate({
                startDate: moment_default()(query.startDate),
                endDate: moment_default()(query.endDate)
            });
        }
    }, [
        query.endDate,
        query.startDate
    ]);
    (0,react.useEffect)(function() {
        if (query.name) {
            setInputText(String(query.name));
        // TODO
        // getGeocode({ address: String(query.name) })
        //   .then((results) => getLatLng(results[0]))
        //   .then(({ lat, lng }) => {
        //     setSearchParams({ lat: lat, lon: lng })
        //   })
        //   .catch((error) => {
        //     // do nothing
        //   })
        }
    }, [
        query.name
    ]);
    (0,react.useEffect)(function() {
        // Local stageに入れる
        localStorage.setItem("search_params", JSON.stringify({
            selectedDate: selectedDate,
            selectedDateTime: selectedDateTime,
            bagSize: bagSizeStepper,
            suitcaseSize: suitcaseSizeStepper
        }));
    }, [
        selectedDate,
        selectedDateTime,
        bagSizeStepper,
        suitcaseSizeStepper
    ]);
    var _handleSelect = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(place) {
            var geocode, lat, lng;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setInputText(place.description);
                        setSearchText("");
                        setPlaces([]);
                        return [
                            4,
                            selectPlace(place)
                        ];
                    case 1:
                        geocode = _state.sent();
                        if (geocode) {
                            lat = geocode.lat, lng = geocode.lng;
                            setLatLng({
                                lat: lat,
                                lon: lng
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(place) {
            return _ref.apply(this, arguments);
        };
    }(), [
        selectPlace,
        setPlaces,
        setSearchText
    ]);
    var _onPressLuggageContainer = (0,react.useCallback)(function(event) {
        if (luggageRef && luggageRef.current.contains(event.target)) {
            setOpenLuggage(true);
        } else {
            setOpenLuggage(false);
            resetInputFocus();
        }
    }, []);
    /**
   * 言語を基にフォーマットを返す
   * @param date moment.Moment 日付データ
   * @param locale string 言語キー
   * @returns
   */ var formattedDateTime = function() {
        var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, locale = arguments.length > 1 ? arguments[1] : void 0;
        if (date === null) {
            return "";
        }
        return locale === "ja" ? date.format("M月D日") : date.format("M/D");
    };
    var applySearchOnParamsDateLuggageModal = function(checkedDate, dateTime, bagSizeStepperCount, suitcaseSizeStepperCount) {
        setSelectedDate({
            startDate: checkedDate.startDate,
            endDate: checkedDate.endDate
        });
        setSelectedDateTime({
            startDateTime: dateTime.startDateTime,
            endDateTime: dateTime.endDateTime
        });
        setBagSizeStepper(bagSizeStepperCount);
        setSuitcaseSizeStepper(suitcaseSizeStepperCount);
    };
    var handleSearchWithCurrentPosition = (0,react.useCallback)(function() {
        var onSearch = function(lat, lon) {
            onPressNavigationSearchSpacePage(inputText, selectedDate, selectedDateTime.startDateTime, selectedDateTime.endDateTime, bagSizeStepper, suitcaseSizeStepper, lat, lon, true);
        };
        if (!(navigator === null || navigator === void 0 ? void 0 : navigator.geolocation)) {
            onSearch(latLng.lat, latLng.lon);
            return;
        }
        setIsRequestLocationPermission(true);
        navigator.geolocation.getCurrentPosition(function(position) {
            var coords = position.coords;
            (0,gtag/* sendGtmLocationEvent */.Tw)(gtag/* GTM_EVENT_USER_LOCATION */.MM, (0,lib_location/* toAnalyticsLocation */.N)(coords.latitude, coords.longitude));
            onSearch(coords.latitude, coords.longitude);
            setIsRequestLocationPermission(false);
        }, function() {
            onSearch(latLng.lat, latLng.lon);
            setIsRequestLocationPermission(false);
        });
    }, [
        inputText,
        selectedDate,
        selectedDateTime,
        bagSizeStepper,
        suitcaseSizeStepper,
        latLng,
        onPressNavigationSearchSpacePage, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((SearchForm_module_default()).search, " ").concat(isHorizontalInputBox ? (SearchForm_module_default()).searchHorizontal : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SearchForm_module_default()).searchForm,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((SearchForm_module_default()).searchInputBox, " ").concat((SearchForm_module_default()).searchInputBoxArea, " ").concat(inputFocusType === "area" ? (SearchForm_module_default()).searchInputBoxFocused : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    className: (SearchForm_module_default()).searchInputBoxLabel,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (SearchForm_module_default()).searchInputBoxLabelText,
                                            children: t("SPACES.SEARCH.AREA.PLACEHOLDER")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (SearchForm_module_default()).searchInputBoxLabelIcon,
                                            src: "/map_pin_icon_navy_dark.svg",
                                            alt: t("META.NOT_MATCHING_SPACE_ICON")
                                        })
                                    ]
                                }),
                                isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    className: (SearchForm_module_default()).searchInputBoxInput,
                                    placeholder: t("SPACES.SEARCH.AREA_MODAL.ENTER_AREA_NAME"),
                                    value: inputText,
                                    onChange: function(event) {
                                        var text = event.target.value;
                                        setSearchTextFromInput(text);
                                        setInputText(text);
                                    },
                                    onFocus: function() {
                                        return setInputFocusType("area");
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "".concat(inputText === "" ? (SearchForm_module_default()).searchInputBoxPlaceholder : (SearchForm_module_default()).searchInputBoxResultAreaText),
                                    onClick: function() {
                                        setIsShowAreaModal(!isShowAreaModal);
                                    },
                                    children: inputText === "" ? t("SPACES.SEARCH.AREA_MODAL.ENTER_AREA_NAME") : inputText
                                }),
                                !!searchText && !!places.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: (SearchForm_module_default()).suggest,
                                    children: places.map(function(suggestion) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: function() {
                                                return _handleSelect(suggestion);
                                            },
                                            className: (SearchForm_module_default()).suggestText,
                                            children: suggestion.description
                                        }, suggestion.place_id);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((SearchForm_module_default()).searchInputBox, " ").concat((SearchForm_module_default()).searchInputBoxDate, " ").concat(inputFocusType === "date" ? (SearchForm_module_default()).searchInputBoxFocused : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    className: (SearchForm_module_default()).searchInputBoxLabel,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (SearchForm_module_default()).searchInputBoxLabelText,
                                        children: t("SPACES.SEARCH.CHECK_DATETIME")
                                    })
                                }),
                                selectedDate.startDate === null && selectedDate.endDate === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (SearchForm_module_default()).searchInputBoxPlaceholder,
                                    onClick: function() {
                                        setInputFocusType("date");
                                        setIsShowDateCalendar(!isShowDateCalendar);
                                    },
                                    children: t("SPACES.SEARCH.ENTER_DATE")
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((SearchForm_module_default()).searchInputBoxResult, " ").concat((SearchForm_module_default()).searchInputBoxResultDate),
                                    onClick: function() {
                                        setInputFocusType("date");
                                        setIsShowDateCalendar(!isShowDateCalendar);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: (SearchForm_module_default()).searchInputBoxResultDateText,
                                            children: [
                                                formattedDateTime(selectedDate.startDate, locale),
                                                " ",
                                                selectedDateTime.startDateTime
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (SearchForm_module_default()).searchInputBoxResultDateText,
                                            children: "-"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: (SearchForm_module_default()).searchInputBoxResultDateText,
                                            children: [
                                                formattedDateTime(selectedDate.endDate, locale),
                                                " ",
                                                selectedDateTime.endDateTime
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (SearchForm_module_default()).searchInputBoxDateCalendar,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(calendars_DateRangeCalendarComponent, {
                                        locale: locale,
                                        isShow: isShowDateCalendar,
                                        isShowTimePicker: true,
                                        onPressCloseModalRequest: function() {
                                            setIsShowDateCalendar(false);
                                        },
                                        selectedDate: selectedDate,
                                        setSelectedDate: setSelectedDate,
                                        selectedDateTime: selectedDateTime,
                                        setSelectedDateTime: setSelectedDateTime
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((SearchForm_module_default()).searchInputBox, " ").concat((SearchForm_module_default()).searchInputBoxLuggage, " ").concat(inputFocusType === "luggage" ? (SearchForm_module_default()).searchInputBoxFocused : ""),
                            ref: luggageRef,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    className: (SearchForm_module_default()).searchInputBoxLabel,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (SearchForm_module_default()).searchInputBoxLabelText,
                                        children: t("SPACES.SEARCH.LUGGAGE.PLACEHOLDER")
                                    })
                                }),
                                bagSizeStepper > 0 || suitcaseSizeStepper > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((SearchForm_module_default()).searchInputBoxResult, " ").concat((SearchForm_module_default()).searchInputBoxResultLuggage),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (SearchForm_module_default()).searchInputBoxResultLuggageCounter,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "".concat((SearchForm_module_default()).searchInputBoxResultLuggageCounterIcon, " ").concat((SearchForm_module_default()).searchInputBoxResultLuggageCounterIconBag),
                                                    src: "/bag_icon_02_gray.svg",
                                                    alt: t("META.PLACEHOLDER_LUGGAGE_ICON")
                                                }),
                                                t("SPACES.SEARCH.LUGGAGE.BAG_SIZE_COUNT_PLACEHOLDER"),
                                                " ",
                                                bagSizeStepper
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (SearchForm_module_default()).searchInputBoxResultLuggageCounter,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "".concat((SearchForm_module_default()).searchInputBoxResultLuggageCounterIcon, " ").concat((SearchForm_module_default()).searchInputBoxResultLuggageCounterIconSuitCase),
                                                    src: "/suitcase_icon_02_gray.svg",
                                                    alt: t("META.PLACEHOLDER_LUGGAGE_ICON")
                                                }),
                                                t("SPACES.SEARCH.LUGGAGE.SUITECASE_SIZE_COUNT_PLACEHOLDER"),
                                                " ",
                                                suitcaseSizeStepper
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (SearchForm_module_default()).searchInputBoxPlaceholder,
                                    onClick: function() {
                                        setInputFocusType("luggage");
                                        _onPressLuggageContainer;
                                    },
                                    children: t("SPACES.SEARCH.ENTER_LUGGAGE_COUNT")
                                }),
                                openLuggage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SearchForm_module_default()).luggageContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (SearchForm_module_default()).luggageContainerBagSize,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (SearchForm_module_default()).luggageContainerCounter,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (SearchForm_module_default()).luggageContainerCounterLabel,
                                                            children: t("COMMON.BAG_SIZE")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LuggageButtonComponent/* default */.Z, {
                                                            sizeStepper: bagSizeStepper,
                                                            setSizeStepper: setBagSizeStepper
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (SearchForm_module_default()).luggageContainerDescription,
                                                    children: t("SPACES.SEARCH.LUGGAGE.BAG_SIZE_DESCRIPTION")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (SearchForm_module_default()).luggageContainerSuiteCaseSize,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (SearchForm_module_default()).luggageContainerCounter,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (SearchForm_module_default()).luggageContainerCounterLabel,
                                                            children: t("COMMON.SUITECASE_SIZE")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LuggageButtonComponent/* default */.Z, {
                                                            sizeStepper: suitcaseSizeStepper,
                                                            setSizeStepper: setSuitcaseSizeStepper
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (SearchForm_module_default()).luggageContainerDescription,
                                                    children: t("SPACES.SEARCH.LUGGAGE.SUITECASE_SIZE_DESCRIPTION")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((SearchForm_module_default()).searchInputBox, " ").concat((SearchForm_module_default()).searchInputBoxDateLuggage),
                            onClick: function() {
                                setIsShowDateLuggageModal(!isShowDateLuggageModal);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    className: (SearchForm_module_default()).searchInputBoxLabel,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (SearchForm_module_default()).searchInputBoxLabelText,
                                            children: t("SPACES.SEARCH.AREA.PLACEHOLDER")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: (SearchForm_module_default()).searchInputBoxLabelIcon,
                                            src: "/calendar_icon_navy_dark.svg",
                                            alt: t("META.PLACEHOLDER_CALENDAR_ICON")
                                        })
                                    ]
                                }),
                                selectedDate.startDate === null && selectedDate.endDate === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (SearchForm_module_default()).searchInputBoxPlaceholder,
                                    children: t("SPACES.SEARCH.SELECT_CHECK_DATETIME_LUGGAGE")
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SearchForm_module_default()).searchInputBoxResult,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (SearchForm_module_default()).searchInputBoxResultDate,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (SearchForm_module_default()).searchInputBoxResultDateText,
                                                    children: [
                                                        selectedDate.startDate !== null && selectedDate.startDate.format("MM/DD"),
                                                        " ",
                                                        selectedDateTime.startDateTime
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (SearchForm_module_default()).searchInputBoxResultDateText,
                                                    children: "-"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (SearchForm_module_default()).searchInputBoxResultDateText,
                                                    children: [
                                                        selectedDate.endDate !== null && selectedDate.endDate.format("MM/DD"),
                                                        " ",
                                                        selectedDateTime.endDateTime
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (SearchForm_module_default()).searchInputBoxResultLuggage,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (SearchForm_module_default()).searchInputBoxResultLuggageCounter,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            className: "".concat((SearchForm_module_default()).searchInputBoxResultLuggageCounterIcon, " ").concat((SearchForm_module_default()).searchInputBoxResultLuggageCounterIconBag),
                                                            src: "/bag_icon_02_gray.svg",
                                                            alt: t("META.PLACEHOLDER_LUGGAGE_ICON")
                                                        }),
                                                        " ",
                                                        "x ",
                                                        bagSizeStepper
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (SearchForm_module_default()).searchInputBoxResultLuggageCounter,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            className: "".concat((SearchForm_module_default()).searchInputBoxResultLuggageCounterIcon, " ").concat((SearchForm_module_default()).searchInputBoxResultLuggageCounterIconSuitCase),
                                                            src: "/suitcase_icon_02_gray.svg",
                                                            alt: t("META.PLACEHOLDER_LUGGAGE_ICON")
                                                        }),
                                                        " ",
                                                        "x ",
                                                        suitcaseSizeStepper
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((SearchForm_module_default()).searchInputBoxButton),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: (SearchForm_module_default()).searchBtn,
                                disabled: isSearchButtonActive,
                                onClick: function() {
                                    page === "top" ? onPressNavigationSearchSpacePage(inputText, selectedDate, selectedDateTime.startDateTime, selectedDateTime.endDateTime, bagSizeStepper, suitcaseSizeStepper, latLng.lat, latLng.lon, false) : onPressSearchSpace(latLng, selectedDate, selectedDateTime, bagSizeStepper, suitcaseSizeStepper);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/search_button_icon_white.svg",
                                        className: (SearchForm_module_default()).searchBtnImage,
                                        alt: "Search"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (SearchForm_module_default()).searchBtnText,
                                        children: t("SPACES.SEARCH.SEARCH_PLACE")
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            isShowAreaModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(spaces_SearchAreaModal, {
                isShow: isShowAreaModal,
                defaultAreaName: inputText,
                onPressCloseModalRequest: function() {
                    setIsShowAreaModal(!isShowAreaModal);
                },
                onPressApplyButton: function(selectedAreaName, selectedLatLng) {
                    console.log("selectedAreaName", selectedAreaName);
                    setInputText(selectedAreaName);
                    setLatLng(selectedLatLng);
                    setIsShowAreaModal(false);
                    //ページによって関数の呼び出し変更
                    if (page === "locations") {
                        onPressSearchSpace(selectedLatLng, selectedDate, selectedDateTime, bagSizeStepper, suitcaseSizeStepper);
                    }
                },
                hideSearchCurrentPosition: page === "locations",
                onPressCurrentPosition: handleSearchWithCurrentPosition,
                isRequestLocationPermission: isRequestLocationPermission
            }),
            isShowDateLuggageModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(spaces_SearchDateLuggageModal, {
                locale: locale,
                isShow: isShowDateLuggageModal,
                onPressCloseModalRequest: function() {
                    setIsShowDateLuggageModal(!isShowDateLuggageModal);
                },
                onPressApplyButton: function(_selectedDate, _selectedDateTime, _bagSizeStepper, _suitcaseSizeStepper) {
                    applySearchOnParamsDateLuggageModal(_selectedDate, _selectedDateTime, _bagSizeStepper, _suitcaseSizeStepper);
                    setIsShowDateLuggageModal(false);
                    //ページによって関数の呼び出し変更
                    if (page === "locations") {
                        onPressSearchSpace(latLng, _selectedDate, _selectedDateTime, _bagSizeStepper, _suitcaseSizeStepper);
                    }
                },
                selectedDate: selectedDate,
                setSelectedDate: setSelectedDate,
                selectedDateTime: selectedDateTime,
                defaultBagSizeStepper: bagSizeStepper,
                defaultSuitcaseSizeStepper: suitcaseSizeStepper,
                isVisibleFilterButton: isVisibleFilterButton,
                onPressSearchFilterModal: onPressSearchFilterModal
            })
        ]
    });
};
/* harmony default export */ var spaces_SearchForm = (SearchForm);


/***/ }),

/***/ 27445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _RatingComponent_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10949);
/* harmony import */ var _RatingComponent_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_RatingComponent_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var RatingComponent = function(param) {
    var averageRating = param.averageRating;
    var rating = String(averageRating).replace(/[.]/g, "-");
    var classNameStr = "ratingStar".concat(rating);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_RatingComponent_module_scss__WEBPACK_IMPORTED_MODULE_1___default().ratingBox),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "".concat((_RatingComponent_module_scss__WEBPACK_IMPORTED_MODULE_1___default().ratingStar), " ").concat((_RatingComponent_module_scss__WEBPACK_IMPORTED_MODULE_1___default())[classNameStr])
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RatingComponent);


/***/ }),

/***/ 21546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ usePlaceAutoCompletion; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(62286);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/lib/axios.ts
var axios = __webpack_require__(61969);
;// CONCATENATED MODULE: ./src/features/places/services/placesAutocompleteApi.ts



var API_PLACES_AUTOCOMPLETE = "/api/web/places/autocomplete";
var fetchPlacesAutocomplete = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input, accessToken) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios/* ecboClient.get */.ZK.get(API_PLACES_AUTOCOMPLETE, {
                            params: {
                                input: input,
                                platform: "web"
                            },
                            headers: accessToken ? {
                                Authorization: "Token ".concat(accessToken)
                            } : undefined
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return function fetchPlacesAutocomplete(input, accessToken) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/features/tracking/lib/location.ts
var lib_location = __webpack_require__(45060);
// EXTERNAL MODULE: ./src/lib/gtag.ts
var gtag = __webpack_require__(31418);
// EXTERNAL MODULE: ./src/state/ducks/locations/apis.ts
var apis = __webpack_require__(89130);
;// CONCATENATED MODULE: ./src/features/places/hooks/usePlaceAutoCompletion.ts











var usePlaceAutoCompletion = function() {
    var cookies = (0,dist.parseCookies)();
    var ref = (0,react.useState)(""), searchText = ref[0], setSearchTextState = ref[1];
    var ref1 = (0,react.useState)([]), places = ref1[0], setPlaces = ref1[1];
    var ref2 = (0,react.useState)(null), status = ref2[0], setStatus = ref2[1];
    // 入力欄への初期値の反映で実行される検索は計測しない
    var isUserInputRef = (0,react.useRef)(false);
    var setSearchText = (0,react.useCallback)(function(text) {
        isUserInputRef.current = false;
        setSearchTextState(text);
    }, []);
    var setSearchTextFromInput = (0,react.useCallback)(function(text) {
        isUserInputRef.current = true;
        setSearchTextState(text);
    }, []);
    var searchPlaces = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(text) {
            var result, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!text) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetchPlacesAutocomplete(text, cookies.jwt_token)
                        ];
                    case 2:
                        result = _state.sent();
                        setStatus(result.status);
                        if (result.status === "OK") {
                            setPlaces(result.predictions);
                        } else {
                            setPlaces([]);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setPlaces([]);
                        setStatus(null);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(text) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cookies.jwt_token
    ]);
    var debouncedSearch = (0,react.useMemo)(function() {
        return lodash_debounce_default()(function(text) {
            if (isUserInputRef.current) {
                (0,gtag/* sendGtmLocationEvent */.Tw)(gtag/* GTM_EVENT_SPACE_ADDRESS_SEARCH */.P$, {
                    search_keyword: text
                });
            }
            searchPlaces(text);
        }, 1000);
    }, [
        searchPlaces
    ]);
    var getGeocode = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(placeId) {
            var result, geometry;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,apis/* goolgeMapGetPlaceDetail */.uu)(placeId, cookies.jwt_token)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.status === "OK") {
                            geometry = result.result.geometry;
                            return [
                                2,
                                geometry.location
                            ];
                        }
                        return [
                            2,
                            null
                        ];
                }
            });
        });
        return function(placeId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cookies.jwt_token
    ]);
    var selectPlace = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(place) {
            var location;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getGeocode(place.place_id)
                        ];
                    case 1:
                        location = _state.sent();
                        if (location) {
                            (0,gtag/* sendGtmLocationEvent */.Tw)(gtag/* GTM_EVENT_LOCATION_SEARCH_SELECT */.CO, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,lib_location/* toAnalyticsLocation */.N)(location.lat, location.lng)), {
                                search_keyword: searchText,
                                selected_location: place.description
                            }));
                        }
                        return [
                            2,
                            location
                        ];
                }
            });
        });
        return function(place) {
            return _ref.apply(this, arguments);
        };
    }(), [
        getGeocode,
        searchText
    ]);
    (0,react.useEffect)(function() {
        if (searchText) {
            debouncedSearch(searchText);
        } else {
            debouncedSearch.cancel();
            setPlaces([]);
            setStatus(null);
        }
        return function() {
            debouncedSearch.cancel();
        };
    }, [
        debouncedSearch,
        searchText
    ]);
    return {
        places: places,
        status: status,
        searchText: searchText,
        setSearchText: setSearchText,
        setSearchTextFromInput: setSearchTextFromInput,
        setPlaces: setPlaces,
        getGeocode: getGeocode,
        selectPlace: selectPlace
    };
};


/***/ }),

/***/ 45060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ toAnalyticsLocation; },
/* harmony export */   "W": function() { return /* binding */ getDistanceInMeters; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);

// 小数点以下3桁 ≈ 110m: 正確な位置は記録せず、エリア単位の需要分析に足る精度
var COORDS_PRECISION = 3;
var AREA_BUCKET_PRECISION = 2;
var EARTH_RADIUS_METERS = 6371000;
// アプリ（lodash の round）と同じく指数表記で桁をずらし、浮動小数点の誤差で丸め結果がずれないようにする
var round = function(value, precision) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("".concat(value).split("e"), 2), base = ref[0], tmp = ref[1], exponent = tmp === void 0 ? "0" : tmp;
    var shifted = Math.round(Number("".concat(base, "e").concat(Number(exponent) + precision)));
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("".concat(shifted).split("e"), 2), shiftedBase = ref1[0], tmp1 = ref1[1], shiftedExponent = tmp1 === void 0 ? "0" : tmp1;
    return Number("".concat(shiftedBase, "e").concat(Number(shiftedExponent) - precision));
};
var toAnalyticsLocation = function(latitude, longitude) {
    var roundedLatitude = round(latitude, COORDS_PRECISION);
    var roundedLongitude = round(longitude, COORDS_PRECISION);
    var areaLatitude = round(latitude, AREA_BUCKET_PRECISION);
    var areaLongitude = round(longitude, AREA_BUCKET_PRECISION);
    return {
        latitude: roundedLatitude,
        longitude: roundedLongitude,
        location_coordinate: "".concat(roundedLatitude.toFixed(COORDS_PRECISION), ",").concat(roundedLongitude.toFixed(COORDS_PRECISION)),
        area_bucket: "".concat(areaLatitude.toFixed(AREA_BUCKET_PRECISION), ",").concat(areaLongitude.toFixed(AREA_BUCKET_PRECISION))
    };
};
var toRadians = function(degrees) {
    return degrees * (Math.PI / 180);
};
var getDistanceInMeters = function(latitude1, longitude1, latitude2, longitude2) {
    var dLatitude = toRadians(latitude2 - latitude1);
    var dLongitude = toRadians(longitude2 - longitude1);
    var a = Math.sin(dLatitude / 2) * Math.sin(dLatitude / 2) + Math.cos(toRadians(latitude1)) * Math.cos(toRadians(latitude2)) * Math.sin(dLongitude / 2) * Math.sin(dLongitude / 2);
    return EARTH_RADIUS_METERS * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};


/***/ }),

/***/ 60849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ calendarWeekHeader; }
/* harmony export */ });
/* unused harmony export generateTimeOptions */
var calendarWeekHeader = {
    Su: {
        en: "Sun",
        ja: "日",
        zh_tw: "日",
        "zh-TW": "日"
    },
    Mo: {
        en: "Mon",
        ja: "月",
        zh_tw: "一",
        "zh-TW": "日"
    },
    Tu: {
        en: "Tue",
        ja: "火",
        zh_tw: "二",
        "zh-TW": "二"
    },
    We: {
        en: "Wed",
        ja: "水",
        zh_tw: "三",
        "zh-TW": "三"
    },
    Th: {
        en: "Thu",
        ja: "木",
        zh_tw: "四",
        "zh-TW": "四"
    },
    Fr: {
        en: "Fri",
        ja: "金",
        zh_tw: "五",
        "zh-TW": "五"
    },
    Sa: {
        en: "Sat",
        ja: "土",
        zh_tw: "六",
        "zh-TW": "六"
    }
};
var generateTimeOptions = function() {
    var minHour = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, maxHour = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 24;
    var times = [];
    for(var hour = minHour; hour <= maxHour; hour++){
        for(var minute = 0; minute < 60; minute += 30){
            if (hour === maxHour && minute === 30) break;
            var formattedHour = hour.toString().padStart(2, "0");
            var formattedMinute = minute.toString().padStart(2, "0");
            times.push("".concat(formattedHour, ":").concat(formattedMinute));
        }
    }
    return times;
};


/***/ }),

/***/ 63267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","stepper":"LuggageButtonComponent_stepper__wr_WK","countDownButton":"LuggageButtonComponent_countDownButton__a9FDt","countUpButton":"LuggageButtonComponent_countUpButton__1WnK1","count":"LuggageButtonComponent_count__KYmL0"};

/***/ }),

/***/ 33162:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","defaultCloseButton":"ModalCloseButtonComponent_defaultCloseButton__KkIP9"};

/***/ }),

/***/ 92328:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","prev":"DateRangeCalendarComponent_prev__YE9eS","next":"DateRangeCalendarComponent_next___vP8K","timePickerContainer":"DateRangeCalendarComponent_timePickerContainer__3_bIJ","timePickerTimes":"DateRangeCalendarComponent_timePickerTimes__dpMe3","timePickerTimeTitle":"DateRangeCalendarComponent_timePickerTimeTitle__PaEUT","timePickerTimeSelect":"DateRangeCalendarComponent_timePickerTimeSelect__sWvIE","timePickerDescription":"DateRangeCalendarComponent_timePickerDescription__ZOHql"};

/***/ }),

/***/ 65184:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","modalOverlay":"ModalLayout_modalOverlay__GOSDW"};

/***/ }),

/***/ 81973:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","suggest":"SearchAreaModal_suggest__S_XwI","suggestText":"SearchAreaModal_suggestText__8Vfbv","modal":"SearchAreaModal_modal__1AelV","modalContainer":"SearchAreaModal_modalContainer__HkI6p","modalCloseButton":"SearchAreaModal_modalCloseButton__mYQIO","modalTitle":"SearchAreaModal_modalTitle__Qykkc","modalApplyButton":"SearchAreaModal_modalApplyButton__fqMVb","areaLabel":"SearchAreaModal_areaLabel__2DGzd","areaInputBox":"SearchAreaModal_areaInputBox__dRfv9","areaInputBoxInput":"SearchAreaModal_areaInputBoxInput__Uebfm","areaChoiceList":"SearchAreaModal_areaChoiceList__646ur","areaChoiceItem":"SearchAreaModal_areaChoiceItem__mlry3","areaChoiceItemNoResult":"SearchAreaModal_areaChoiceItemNoResult__8tEM8","areaChoiceButton":"SearchAreaModal_areaChoiceButton__5334_","areaChoiceIconCurrent":"SearchAreaModal_areaChoiceIconCurrent__36trE","areaChoiceText":"SearchAreaModal_areaChoiceText__L8P_b"};

/***/ }),

/***/ 86751:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","modal":"SearchDateLuggageModal_modal__7rC_n","modalContainer":"SearchDateLuggageModal_modalContainer__PF_Te","modalCloseButton":"SearchDateLuggageModal_modalCloseButton__XlgB1","modalTitle":"SearchDateLuggageModal_modalTitle__3TCPF","modalApplyButton":"SearchDateLuggageModal_modalApplyButton__QB2HG","dateLabel":"SearchDateLuggageModal_dateLabel__7exSY","dateInputBox":"SearchDateLuggageModal_dateInputBox__P4aaK","dateInputBoxPlaceholder":"SearchDateLuggageModal_dateInputBoxPlaceholder___kdsL","dateInputBoxPlaceholderDate":"SearchDateLuggageModal_dateInputBoxPlaceholderDate__VwHPL","dateInputBoxDateCalendar":"SearchDateLuggageModal_dateInputBoxDateCalendar__WKKnq","dateInputBoxResultDate":"SearchDateLuggageModal_dateInputBoxResultDate__3r2Tn","dateInputBoxResultDateText":"SearchDateLuggageModal_dateInputBoxResultDateText__U7VLV","dateBox":"SearchDateLuggageModal_dateBox__rTl1G","dateTimeSelect":"SearchDateLuggageModal_dateTimeSelect__FGmqc","dateTimeDescription":"SearchDateLuggageModal_dateTimeDescription__eEoy1","dateTimeContents":"SearchDateLuggageModal_dateTimeContents__kTWNb","luggage":"SearchDateLuggageModal_luggage__U4GSl","luggageIcon":"SearchDateLuggageModal_luggageIcon__6AXRr","luggageLabel":"SearchDateLuggageModal_luggageLabel__oTFSr","luggageDescription":"SearchDateLuggageModal_luggageDescription__5kllv","luggageStepper":"SearchDateLuggageModal_luggageStepper__uOu46","luggageStepperButton":"SearchDateLuggageModal_luggageStepperButton__GwdCG","luggageContents":"SearchDateLuggageModal_luggageContents__4BFQ_","filterContent":"SearchDateLuggageModal_filterContent__rYSag","filterButton":"SearchDateLuggageModal_filterButton__DU6Ow","filterButtonIcon":"SearchDateLuggageModal_filterButtonIcon__M8sCg","filterButtonText":"SearchDateLuggageModal_filterButtonText__PbrY4"};

/***/ }),

/***/ 77922:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","search":"SearchForm_search__uJ3cz","searchForm":"SearchForm_searchForm__6pcT_","searchInputBox":"SearchForm_searchInputBox__2Av6S","searchInputBoxLabel":"SearchForm_searchInputBoxLabel__7NhvC","searchInputBoxLabelText":"SearchForm_searchInputBoxLabelText__2t8Pa","searchInputBoxLabelIcon":"SearchForm_searchInputBoxLabelIcon__jPKsZ","searchInputBoxInput":"SearchForm_searchInputBoxInput__krSdN","searchInputBoxPlaceholder":"SearchForm_searchInputBoxPlaceholder__ivD8T","searchInputBoxFocused":"SearchForm_searchInputBoxFocused__eq3L6","searchInputBoxResultDate":"SearchForm_searchInputBoxResultDate__DEu7G","searchInputBoxResultDateText":"SearchForm_searchInputBoxResultDateText__mqU2a","searchInputBoxResultLuggage":"SearchForm_searchInputBoxResultLuggage__ubCwO","searchInputBoxResultLuggageCounter":"SearchForm_searchInputBoxResultLuggageCounter__Nnq5m","searchInputBoxResultLuggageCounterIcon":"SearchForm_searchInputBoxResultLuggageCounterIcon__2vIXI","searchInputBoxResultLuggageCounterIconBag":"SearchForm_searchInputBoxResultLuggageCounterIconBag__UVV7u","searchInputBoxResultLuggageCounterIconSuitCase":"SearchForm_searchInputBoxResultLuggageCounterIconSuitCase__iSaly","searchInputBoxArea":"SearchForm_searchInputBoxArea__JBQpI","searchInputBoxDate":"SearchForm_searchInputBoxDate__kFNj5","searchInputBoxDateCalendar":"SearchForm_searchInputBoxDateCalendar__w_3ls","searchInputBoxLuggage":"SearchForm_searchInputBoxLuggage__a_P7B","searchInputBoxDateLuggage":"SearchForm_searchInputBoxDateLuggage__OWm32","searchInputBoxButton":"SearchForm_searchInputBoxButton__jyN_4","searchBtn":"SearchForm_searchBtn__QdA_o","searchBtnImage":"SearchForm_searchBtnImage__4eNji","searchBtnText":"SearchForm_searchBtnText__IbnA_","searchHorizontal":"SearchForm_searchHorizontal__U_iZ2","luggageContainer":"SearchForm_luggageContainer__pQcov","searchBtnIcon":"SearchForm_searchBtnIcon__S18JH","searchBtnIconImage":"SearchForm_searchBtnIconImage__jtLzq","suggest":"SearchForm_suggest__KNMGC","suggestText":"SearchForm_suggestText__q0ciI","luggageContainerBagSize":"SearchForm_luggageContainerBagSize__TW1hQ","luggageContainerSuiteCaseSize":"SearchForm_luggageContainerSuiteCaseSize__qnTSU","luggageContainerCounter":"SearchForm_luggageContainerCounter__z6iIM","luggageContainerCounterLabel":"SearchForm_luggageContainerCounterLabel__D8q8R","luggageContainerDescription":"SearchForm_luggageContainerDescription__vcCfb","searchInputBoxResult":"SearchForm_searchInputBoxResult__bQtN_","searchInputBoxResultAreaText":"SearchForm_searchInputBoxResultAreaText__CSCyA"};

/***/ }),

/***/ 10949:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","ratingBox":"RatingComponent_ratingBox__LqCBw","ratingStar":"RatingComponent_ratingStar__VgGRN","ratingStar1":"RatingComponent_ratingStar1__ELLTd","ratingStar2":"RatingComponent_ratingStar2__Oc3NU","ratingStar3":"RatingComponent_ratingStar3__TXmko","ratingStar4":"RatingComponent_ratingStar4__5u03z","ratingStar5":"RatingComponent_ratingStar5__ghgiF","ratingStar1-1":"RatingComponent_ratingStar1-1__dHK0a","ratingStar1-2":"RatingComponent_ratingStar1-2__gNjxK","ratingStar1-3":"RatingComponent_ratingStar1-3__aZ1Pt","ratingStar1-4":"RatingComponent_ratingStar1-4__73y97","ratingStar1-5":"RatingComponent_ratingStar1-5__H_aLK","ratingStar1-6":"RatingComponent_ratingStar1-6__V1vr9","ratingStar1-7":"RatingComponent_ratingStar1-7__9G1HH","ratingStar1-8":"RatingComponent_ratingStar1-8__TV6GC","ratingStar1-9":"RatingComponent_ratingStar1-9__3r5TM","ratingStar2-1":"RatingComponent_ratingStar2-1__edoU6","ratingStar2-2":"RatingComponent_ratingStar2-2__6Ie_J","ratingStar2-3":"RatingComponent_ratingStar2-3__DT2P_","ratingStar2-4":"RatingComponent_ratingStar2-4__9Ogdy","ratingStar2-5":"RatingComponent_ratingStar2-5__Jg4Ql","ratingStar2-6":"RatingComponent_ratingStar2-6__vXcm7","ratingStar2-7":"RatingComponent_ratingStar2-7__eOZKn","ratingStar2-8":"RatingComponent_ratingStar2-8__O_3OS","ratingStar2-9":"RatingComponent_ratingStar2-9__soQsD","ratingStar3-1":"RatingComponent_ratingStar3-1__LPqyM","ratingStar3-2":"RatingComponent_ratingStar3-2__QLwnQ","ratingStar3-3":"RatingComponent_ratingStar3-3__fflbE","ratingStar3-4":"RatingComponent_ratingStar3-4__3F9tI","ratingStar3-5":"RatingComponent_ratingStar3-5__05riE","ratingStar3-6":"RatingComponent_ratingStar3-6__8y2sO","ratingStar3-7":"RatingComponent_ratingStar3-7__1eq_U","ratingStar3-8":"RatingComponent_ratingStar3-8__MZmwU","ratingStar3-9":"RatingComponent_ratingStar3-9__RcJWR","ratingStar4-1":"RatingComponent_ratingStar4-1__vu1d8","ratingStar4-2":"RatingComponent_ratingStar4-2__mmEhQ","ratingStar4-3":"RatingComponent_ratingStar4-3__LGOE8","ratingStar4-4":"RatingComponent_ratingStar4-4__N6A0T","ratingStar4-5":"RatingComponent_ratingStar4-5__gvqu_","ratingStar4-6":"RatingComponent_ratingStar4-6__KV5p7","ratingStar4-7":"RatingComponent_ratingStar4-7__nL8XX","ratingStar4-8":"RatingComponent_ratingStar4-8__xc6sI","ratingStar4-9":"RatingComponent_ratingStar4-9__dwmy9"};

/***/ })

}]);